export const mood = `#version 300 es
precision highp float;
#define PI 3.14159265359
uniform vec2 u_resolution;
uniform float u_time, u_siize, u_ws;
out vec4 final;

float map(float value, float min1, float max1, float min2, float max2) {
    return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
    }

float rectshape(vec2 position,vec2 scale){
   scale=vec2(.5)-scale*.5;
   vec2 shaper=vec2(step(scale.x,position.x),step(scale.y,position.y));
   shaper*=vec2(step(scale.x,1.-position.x),step(scale.y,1.-position.y));
   return shaper.x*shaper.y;}
   
void main(){




   vec2 position=gl_FragCoord.xy/u_resolution;
   vec3 color=mix(vec3(0.102,0.204,0.647),vec3(0.933,0.204,0.059),abs(cos(u_time*0.0005)));
   vec3 colorForRectTwo=vec3(0.0, 0.0, 0.0);

   float h2 = map(u_siize, 0.0, 1.0, 0.2, 1.0);
   float h3 = map(u_siize, 0.0, 1.0, 0.05, 1.0);

   
   vec3 color2=mix(vec3(0.102,0.204,0.647),vec3(0.933,0.204,0.059),abs(sin(u_time*0.0005)));
   float rectangle=rectshape(position,vec2(u_siize,u_siize));
   float rectangleTwo=rectshape(position,vec2(u_siize-.001,u_siize-.001));
   

   if(u_ws > 0.0){
    rectangle=rectshape(position,vec2(h2, h3));
     rectangleTwo=rectshape(position,vec2(h2-.001,h3-.001));
   }
   if (rectangle > 0.0) {
       color2 = color;
   }
   if (rectangleTwo > 0.0) {
       color2 = colorForRectTwo;
   }
    
   final=vec4(color2,1.);
}`